
import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { MasterInfoCacheViewModel } from './masterInfoCacheViewModel';

export class MasterInfoCacheContainer extends MasterDataContainer<MasterInfoCacheViewModel> {
    constructor(models: Array<MasterInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
